import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
// const url2 = process.env.VUE_APP_IMG_URL;
const jsona = new Jsona();

function list (params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/users`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function listEmployees (params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        }
    };
    return axios.get(`${url}/users?filter[model_type]=Employee`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
        delete id.id;
    }

    return axios.get(`${url}/users/${id}?include=roles,permissions,model`, options)
        .then(response => {
            let user = jsona.deserialize(response.data);
            delete user.links;
            return user;
        });
}

function add (user) {
    const payload = jsona.serialize({
        stuff: user,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/users?include=roles,permissions`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (user) {
    const payload = jsona.serialize({
        stuff: user,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/users/${user.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}
function changePassword (user) {
    const payload = jsona.serialize({
        stuff: user,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/users/password/change/${user.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/users/${id}`, options);
}

function permissions (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/users/${id}/permissions`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}
function upload (user, image) {
    const payload = new FormData();
    payload.append('attachment', image);

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.post(`${url}/uploads/profiles/${user.id}/profile_image`, payload,options)
        .then(response => {
            return response.data.url;
        });
}
function uploadsign (item, image) {
    const bodyFormData = new FormData();
    console.log(item);
    console.log(image);
    bodyFormData.append('attachment', image);

    return axios.post(`${url}/uploads/users/${item.id}/signature`, bodyFormData)
        .then(response => {
            return response.data.url;
        });
}

export default {
    list,
    get,
    permissions,
    listEmployees,
    add,
    update,
    destroy,
    upload,
    uploadsign,
    changePassword,
};

